@if (loading()) {
  <div
    class="bucket-transaction-list-loading flex min-h-48 flex-1 flex-col items-center justify-center gap-4 text-text-muted"
    role="status"
  >
    <span
      class="inline-flex h-9 w-9 animate-spin rounded-full border-2 border-border border-t-brand-accent-strong"
      aria-hidden="true"
    ></span>
    <span class="text-body-sm font-semibold">Loading transactions...</span>
  </div>
} @else if (!hideTransactionList) {
  <app-infinite-transaction-list
    class="flex h-full min-h-0 flex-1 flex-col"
    [transactionDataSource]="transactionDataSource"
    [options]="{ isInDrawer: true, bucketId: bucket()?.id }"
    [scrollResetKey]="bucket()?.id + ':' + bucket()?.monthYear"
  />
} @else {
  @if (accountsQuery.data()?.totalRecords === 1) {
    <div class="empty-list">
      <div class="empty-list-graphic-card">
        <img src="assets/images/emptycard.svg" alt="credit card graphic" />
      </div>
      <div class="empty-list-content">
        <p>Almost there! Link your financial<br />accounts to start budgeting.</p>
        <div class="flex-row empty-list-link-actions">
          <a appUiButton [routerLink]="['/accounts']">Link Bank Account</a>
        </div>
      </div>
    </div>
  } @else {
    <div class="empty-list">
      <div class="empty-list-graphic-transactions">
        <img src="assets/images/emptytransactions.svg" alt="guy holding a coin" />
      </div>
      <div class="empty-list-content">
        <p>Transactions sorted into this<br />budget will show up here.</p>

        @if (showEmptyActions()) {
          <div class="flex-row empty-list-actions">
            <a appUiButton appearance="outline" [routerLink]="['/transactions']">View All</a>
          </div>
        }
      </div>
    </div>
  }
}
